export default {
  name: "Template Helper",
  data() {
    return {};
  },
  methods: {
    prepareExecutionObject() {
      this.executionValues = [];

      console.log("this.fieldsData", this.fieldsData);

      this.fieldsData.forEach((fd) => {
        if (fd.input_type === "FORMULA") {
          const selectedFields = (fd.selected_fields || [])
            .filter((e) => e.type === "FIELD")
            .map((e) => e.key);

          this.executionValues.push({
            type: "FORMULA",
            values: selectedFields,
          });
        }
      });

      console.log("Execution values prepared:", this.executionValues);
    },
    getChangedKeys(form1, form2) {
      const changedKeys = [];

      const allKeys = new Set([...Object.keys(form1), ...Object.keys(form2)]);

      allKeys.forEach((key) => {
        if (
          (!(key in form1) && form2[key]) ||
          (!(key in form2) && form1[key]) ||
          form1[key] !== form2[key]
        ) {
          changedKeys.push(key);
        }
      });

      return changedKeys;
    },

    prepareExecutionFormRulesObject() {
      this.formRulesDependentFields = this.fieldsData
        .filter(
          (fd) =>
            this.templateRules.filter(
              (rule) =>
                rule.conditions.filter((cond) => cond.selectField == fd.key)
                  .length
                  || 
                   rule.actions.filter((act) => act.value == fd.key && act.data_source=='TEMPLATE')
                  .length

            ).length
        )
        .map((fd) => fd.key);
    },
  },
};
